import { useState, useEffect } from 'react';

/**
 * Hook to fetch the current user's payout account status.
 * Returns { hasAccount, maskedAccount, loading, error }.
 */
export const usePayoutAccountStatus = () => {
  const [hasAccount, setHasAccount] = useState(false);
  const [maskedAccount, setMaskedAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const csrfMeta = document.querySelector('meta[name="csrf-token"]');
        const csrfToken = csrfMeta ? csrfMeta.getAttribute('content') : '';

        const response = await fetch('/api/payout_account/status', {
          headers: {
            'Accept': 'application/json',
            'X-CSRF-Token': csrfToken
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch payout account status');
        }

        const data = await response.json();
        setHasAccount(data.has_account);
        setMaskedAccount(data.masked_account);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, []);

  return { hasAccount, maskedAccount, loading, error };
};
